import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL, SITE_NAME } from "../seoConfig";

export default function StructuredData() {
  const data = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/assets/images/logo/LIA_logo.png`,
    description:
      "Founded in 1990 in Syosset, NY, Long Island Academy helps K‑12 students improve academics and attitudes with dedicated teachers and a motivating curriculum.",
    sameAs: [
      // Add real profiles when available
      // "https://www.facebook.com/…",
      // "https://www.instagram.com/…",
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}


